module.exports = __webpack_public_path__ + "static/media/gifautocomplete.b4c735b2.gif";